import {useShowNavigation} from '@hooks';
import {Navigation} from '../../Navigation';

export const Header = () => {
  const showNavigation = useShowNavigation();

  return (
    <div
      className="hidden sm:flex items-center justify-center border-b sticky px-4 top-0 z-10 bg-white"
      style={{gridArea: 'header / fullbleed'}}>
      {showNavigation && <Navigation footer={false} />}
    </div>
  );
};
